import React, { memo, useCallback } from 'react'

import { Icon, Add, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function NewModelCard({ onNavigate }) {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = location?.pathname === '/ai'

  const handleClick = useCallback(() => {
    clearModelSettings()
    if (location?.pathname !== '/ai') {
      navigate('/ai')
    }
    onNavigate('new')
  }, [navigate, location, onNavigate])

  return (
    <div
      className={classnames('model-card', 'model-card--new', isActive && 'model-card--active')}
      onClick={handleClick}
    >
      <div className="model-card__new">
        <Icon svgComponent={Add} size={iconSizeMedium} color="dark" notSpaced />
        <span className="model-card__new-text">Generate New<br/>3D Model</span>
      </div>
    </div>
  )
}

NewModelCard.propTypes = {
  onNavigate: func.isRequired,
}

export default memo(NewModelCard)
